import { standard } from '../../constants';

export default {
  ...standard('GET', 'organizations'),
  ...standard('SELECT', 'organizations'),
};



// WEBPACK FOOTER //
// ./src/modules/organizations/constants.js